import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import { Form } from 'informed';
import { BaseForm } from '../../base';
import Axios from 'axios';
import { API_HOST } from '../../consts';
import InputSelect from '../../components/inputs/InputSelect';
import InputSummernote from '../../components/inputs/InputSummernote';
import { toast } from 'react-toastify';

const mapStatus = (s) => ({
  value: s.id,
  label: s.descricao
});

class ItemActionAppealModal extends BaseForm {
  state = {
    status: []
  };

  fetchStatus() {
    return Axios.get(`${API_HOST}/recursos/status`).then((response) => {
      this.setState({
        status: response.data.map(mapStatus)
      });
    });
  }

  componentDidMount() {
    this.fetchStatus();
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const { idsSelecionados, onSuccess } = this.props;
    const { formState } = this.state;
    const values = formState ? formState.values : {};

    if (!idsSelecionados.length) {
      toast.error('Selecione um ou mais recursos para analisar.');
      return;
    }

    Promise.all(
      idsSelecionados.map((id) =>
        Axios.patch(
          `${API_HOST}/recursos/recurso/${id}/update_julgamento`,
          values
        )
      )
    )
      .then(() => {
        toast.success('Recursos atendidos com sucesso.');
        onSuccess();
      })
      .catch(this.onValidateError);
  };

  render() {
    const { status } = this.state;
    const { isOpen, toggle, title } = this.props;

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <Form
          onChange={(formState) => this.setState({ formState })}
          getApi={(formApi) => {
            this.formApi = formApi;
          }}
        >
          <ModalHeader toggle={toggle}>{title}</ModalHeader>
          <ModalBody>
            <React.Fragment>
              <div className="row mt-3">
                <InputSelect
                  required={this.isRequired('recurso.status')}
                  col="col-sm-8"
                  label="Estado do Recurso"
                  field="status"
                  options={status}
                />
              </div>
              <hr />

              <InputSummernote
                required={this.isRequired('recurso.julgamento')}
                col="col-sm-12"
                label="Julgamento"
                field="julgamento"
              />
              <InputSummernote
                required={this.isRequired('recurso.medida')}
                col="col-sm-12"
                label="Medida"
                field="medida"
              />
            </React.Fragment>
          </ModalBody>
          <ModalFooter>
            <button className="btn primary-button" onClick={this.handleSubmit}>
              OK
            </button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

ItemActionAppealModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  validTitle: PropTypes.string,
  invalidTitle: PropTypes.string,
  idsSelecionados: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  onSuccess: PropTypes.func,
  valid: PropTypes.arrayOf(PropTypes.number),
  invalid: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.number,
      errors: PropTypes.arrayOf(PropTypes.string)
    })
  )
};

ItemActionAppealModal.defaultProps = {
  isOpen: false,
  title: '',
  validTitle: '',
  invalidTitle: '',
  idsSelecionados: [],
  onSuccess: () => {},
  valid: [],
  invalid: []
};

export default ItemActionAppealModal;
